import { createFileRoute } from '@tanstack/react-router';
import { RouteName } from '@mews-commander/enums';
import {
    ProductServiceAccountingPage,
    useGetAdditionalServiceName,
} from '@mews-commander/modules/src/modules/productService';
import { MewsTeam, RouteType } from '@mews/enums';

function Component() {
    const { currentEnterpriseId, id } = Route.useParams();
    const additionalServicesName = useGetAdditionalServiceName(id);

    return (
        <ProductServiceAccountingPage
            enterpriseId={currentEnterpriseId}
            productServiceId={id}
            additionalServicesName={additionalServicesName}
        />
    );
}

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/ProductService/Accounting/$id')({
    component: Component,
    staticData: {
        routeName: RouteName.ProductServiceAccountingIndex,
        owner: MewsTeam.Accounting,
        type: RouteType.Frontend,
    },
});
